import { useEffect, useState } from "react";
import {
  OrderStatus,
  PricelistOffersGetByIdSubcontractorOffers,
  SubcontractorOffersStatus,
} from "../../../../services/orders/pricelist-offers-get-by-id/types";
import styled from "styled-components";
import { GridColDef } from "@mui/x-data-grid";

import { StyledTable } from "../../../../components/table/styled-table";
import { theme } from "../../../../helpers/theme";
import { useFormik } from "formik";
import {
  getServiceFromEnum,
  getTypeOfPackage,
  priceFormating,
} from "../helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteOfferPosition } from "../../../../services/offers/delete-offer-position";
import { StyledDialog } from "../../../../components/dialog/dialog";
import { LoadingBackDrop } from "../../../../components/loader";
import { toast } from "react-toastify";
import { settings } from "../../../../helpers/toast.settings";
import { deleteOfferSubcontractor } from "../../../../services/offers/delete-offer-subcontractor";
import { offerSubcontractorUpdate } from "../../../../services/offers/update-offer-subcontractor";
import { useNavigate } from "react-router-dom";
import { offerSubcontractorNotification } from "../../../../services/offers/offer-subcontractor-notification";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

interface OfferingSubcontractorsOffersProps {
  subcontractorOffer: PricelistOffersGetByIdSubcontractorOffers;
  additionalServicesQuantity: number;
  isDeletable: boolean;
}
const OfferingSubcontractorsOffers = ({
  subcontractorOffer,
  additionalServicesQuantity,
  isDeletable,
}: OfferingSubcontractorsOffersProps) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [openPositionDialog, setOpenPositionDialog] = useState(false);
  const [positionId, setPositionId] = useState("");
  const [openSubcontractorOfferDialog, setOpenSubcontractorOfferDialog] =
    useState(false);

  const deleteOfferPositionMutation = useMutation(deleteOfferPosition, {
    onSuccess: () => {
      queryClient.invalidateQueries(["OrdersPricelistOffers"]);
    },
  });
  const deleteSubcontractorOfferMutation = useMutation(
    deleteOfferSubcontractor,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["OrdersPricelistOffers"]);
      },
    }
  );
  const updateOfferSubconstructorMutation = useMutation(
    offerSubcontractorUpdate,
    {}
  );
  const offerSubcontractorNotificationMutation = useMutation(
    offerSubcontractorNotification,
    {
      onSuccess: () => {
        toast.success("Pomyślnie wysłano powiadomienie!", {
          toastId: "NotificationSendSuccess",
          ...settings,
        });
      },
    }
  );
  const { data }: any = queryClient.getQueryState([
    "OrdersPricelistOffers",
  ])?.data;

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 180,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <ButtonsWrapper>
          <Button
            variant="contained"
            style={{
              backgroundColor: "orange",
            }}
            onClick={() => {
              return navigate(
                `/operator/orders/offering/position-edit/${params.id}`
              );
            }}
          >
            Edytuj
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "red",
            }}
            onClick={() => {
              setPositionId(params.row.id);
              if (
                data.payload.status_zamowienia ===
                  OrderStatus.W_trakcie_realizacji ||
                data.payload.status_zamowienia === OrderStatus.Zrealizowano ||
                !isDeletable
              ) {
                toast.error("Nie możesz usuwać zatwierdzonej oferty", {
                  toastId: "Cannot delete position",
                  ...settings,
                });
              } else setOpenPositionDialog(true);
            }}
          >
            Usuń
          </Button>
          <StyledDialog
            open={openPositionDialog}
            setOpen={setOpenPositionDialog}
            confirmFunction={() =>
              deleteOfferPositionMutation.mutate({
                id_pozycji_oferty: positionId,
              })
            }
            dialogContent="Czy na pewno chcesz usunąć pozycję oferty?"
          />
        </ButtonsWrapper>
      ),
    },

    { field: "usluga", headerName: "Usługa", width: 200 },
    { field: "cena_cennik", headerName: "Cena z cennika", width: 200 },
    { field: "cena_ostateczna", headerName: "Cena ostateczna", width: 150 },
    { field: "obiekt", headerName: "Obiekt", width: 150 },
    {
      field: "ilosc",
      headerName: "Ilość",
      width: 100,
    },
    {
      field: "wyliczone_m2",
      headerName: "Wyliczone m2",
      width: 150,
    },
    {
      field: "wycena",
      headerName: "Wycena",
      width: 150,
    },
  ];
  const rows = subcontractorOffer.pozycje_oferty.map((r) => ({
    id: r.id_pozycja_oferty,
    usluga: getServiceFromEnum(r.Usluga),
    cena_cennik: r.cennik ? priceFormating(r.cennik.stawka_netto) : "-",
    cena_ostateczna: r.cena_docelowa ? priceFormating(r.cena_docelowa) : "-",
    obiekt: getTypeOfPackage(r.obiekt),
    ilosc:r.ilosc?r.ilosc:"-",
    // additionalServicesQuantity?r.ilosc:"-",
    //   r.Usluga === 3 ||
    //   r.Usluga === 4 ||
    //   r.Usluga === 5 ||
    //   r.Usluga === 6 ||
    //   r.Usluga === 7 ||
    //   r.Usluga === 8
    //     ? additionalServicesQuantity
    //       ? additionalServicesQuantity
    //       : "-"
    //     : r.ilosc,
    wyliczone_m2: `${r.rozmiarm2.toFixed(2)} m2`,
    wycena: r.wymaga_wyceny ? "Wymaga" : "Nie wymaga",
  }));
  const formik = useFormik({
    initialValues: {
      status_oferty_podwykonawcy: subcontractorOffer.status_oferty_podwykonawcy,
    },

    onSubmit: (values) => {},
  });
  useEffect(() => {
    if (
      subcontractorOffer.status_oferty_podwykonawcy !==
      formik.values.status_oferty_podwykonawcy
    ) {
      updateOfferSubconstructorMutation.mutate({
        id_oferty_podwykonawcy: subcontractorOffer.id_oferta_podwykonawcy,
        status_oferty_podwykonawcy: formik.values.status_oferty_podwykonawcy,
        id_magazynu: subcontractorOffer.id_magazyn,
      });
    }
  }, [formik.values.status_oferty_podwykonawcy]);

  return (
    <TableAndTableInfoWrapper>
      <TableInfo>
        <OfferSubcontractorName>{`Oferta podwykonawcy: ${subcontractorOffer.magazyn.wykonawca[0].nazwa}`}</OfferSubcontractorName>
        <Button
          variant="contained"
          style={{
            backgroundColor: "red",
          }}
          onClick={() => {
            if (
              data.payload.status_zamowienia ===
                OrderStatus.W_trakcie_realizacji ||
              data.payload.status_zamowienia === OrderStatus.Zrealizowano ||
              !isDeletable
            ) {
              toast.error("Nie możesz usuwać zatwierdzonej oferty", {
                toastId: "Cannot delete position",
                ...settings,
              });
            } else setOpenSubcontractorOfferDialog(true);
          }}
        >
          Usuń
        </Button>
        <StyledDialog
          open={openSubcontractorOfferDialog}
          setOpen={setOpenSubcontractorOfferDialog}
          confirmFunction={() =>
            deleteSubcontractorOfferMutation.mutate({
              id_oferty_podwykonawcy: subcontractorOffer.id_oferta_podwykonawcy,
            })
          }
          dialogContent="Czy na pewno chcesz usunąć ofertę podwykonawcy?"
        />
        <FormControl sx={{ minWidth: "200px" }}>
          <InputLabel id="status_oferty_podwykonawcy_label">
            Status oferty
          </InputLabel>
          <Select
            placeholder="Status oferty"
            labelId="status_oferty_podwykonawcy_label-label"
            label="Status oferty"
            id="status_oferty_podwykonawcy"
            name="status_oferty_podwykonawcy"
            value={formik.values.status_oferty_podwykonawcy}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <MenuItem value={0}>Nie wymaga potwierdzenia</MenuItem>
            <MenuItem value={1}>Wymaga potwierdzenia</MenuItem>
            <MenuItem value={2}>Potwierdzono</MenuItem>
            <MenuItem value={3}>Nie potwierdzono</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          style={{
            backgroundColor: theme.colors.blue01_active,
            width: "210px",
          }}
          onClick={() => {
            if (
              formik.values.status_oferty_podwykonawcy !==
              SubcontractorOffersStatus.wymaga_potwierdzenia
            ) {
              toast.error(
                "Status oferty podwykonawcy musi być Wymaga potwierdzenia",
                {
                  toastId: "SubcontractorOfferStatus is incorrect",
                  ...settings,
                }
              );
            } else
              offerSubcontractorNotificationMutation.mutate({
                oferta_id: subcontractorOffer.id_oferta_podwykonawcy,
              });
          }}
        >
          Wyślij powiadomienie
        </Button>
        <Button
          variant="contained"
          style={{
            backgroundColor: theme.colors.blue01_active,
            width: "150px",
          }}
          onClick={() => {
            navigate(
              `/operator/orders/offering/position-add/${subcontractorOffer.id_oferta_podwykonawcy}`
            );
          }}
        >
          Dodaj pozycję
        </Button>
        <OfferPrice>{`Cena całkowita: ${priceFormating(
          subcontractorOffer.pozycje_oferty.reduce(
            (accumulator, currentValue) =>
              accumulator +
              (currentValue.cena_docelowa ? currentValue.cena_docelowa : 0),

            0
          )
        )}`}</OfferPrice>
      </TableInfo>
      <StyledTable
        getRowId={(row: any) => row?.id}
        rows={rows}
        columns={columns}
        hideFooter={true}
        pageSize={rows.length}
        disableSelectionOnClick={true}
        autoHeight
      />
    </TableAndTableInfoWrapper>
  );
};

export default OfferingSubcontractorsOffers;

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
const TableAndTableInfoWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
const TableInfo = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 20px;
  align-items: center;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  flex-wrap: wrap;
  @media ${theme.device.Mtablet} {
    justify-content: space-around;
    gap: 10px;
  }
  @media ${theme.device.Mlaptop} {
    width: 94%;
  }
`;
const OfferSubcontractorName = styled.span`
  display: flex;

  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
const OfferPrice = styled.span`
  display: flex;

  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-right: 6px;
`;
